export default __webpack_public_path__ + "static/media/S-012.7535dbcd.png";